import { render, staticRenderFns } from "./prescriptionItem.vue?vue&type=template&id=9e36d7fe&scoped=true"
import script from "./prescriptionItem.vue?vue&type=script&lang=js"
export * from "./prescriptionItem.vue?vue&type=script&lang=js"
import style0 from "./prescriptionItem.vue?vue&type=style&index=0&id=9e36d7fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e36d7fe",
  null
  
)

export default component.exports